import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgViewOff = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M20.53 3.47a.75.75 0 0 1 0 1.06l-16 16a.75.75 0 0 1-1.06-1.06l2.625-2.625c-1.484-.956-2.735-2.128-3.674-3.17a2.495 2.495 0 0 1 0-3.35C4.394 8.135 7.854 5.25 12 5.25c1.647 0 3.184.457 4.553 1.136L19.47 3.47a.75.75 0 0 1 1.06 0m-5.104 4.044c-1.08-.474-2.23-.764-3.426-.764-3.48 0-6.558 2.465-8.466 4.58a.995.995 0 0 0 0 1.34c.94 1.043 2.19 2.197 3.65 3.086l1.687-1.688a3.75 3.75 0 0 1 5.197-5.197zM12.97 9.969A2.25 2.25 0 0 0 9.97 12.97zm5.23-1.723a.75.75 0 0 1 1.055-.12c.9.72 1.683 1.487 2.325 2.198a2.495 2.495 0 0 1 0 3.351c-1.975 2.19-5.434 5.075-9.58 5.075-.83 0-1.632-.116-2.398-.318a.75.75 0 0 1 .382-1.45A8 8 0 0 0 12 17.25c3.48 0 6.558-2.465 8.466-4.58a.995.995 0 0 0 0-1.341c-.597-.66-1.32-1.37-2.147-2.03a.75.75 0 0 1-.118-1.053m-3.113 3.567a.75.75 0 0 1 .6.874 3.75 3.75 0 0 1-3 3 .75.75 0 0 1-.273-1.475 2.25 2.25 0 0 0 1.798-1.798.75.75 0 0 1 .874-.601"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgViewOff;
